import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import { UsersProvider } from "./context/usersContext";
import App from "./app";
import { UserProvider } from "./context/user";
import { Toaster } from "react-hot-toast";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { loadConfig } from "./config";
import env from "./config/env";

async function bootstrap() {
  const config = await loadConfig();
  Object.assign(env, config);

  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(

    <BrowserRouter>
      <UserProvider>
        <UsersProvider>
          <GoogleOAuthProvider clientId={'4414070894-n3hd59hhhk8cr1tlee8ekaattc7udtgk.apps.googleusercontent.com'}>
            <App />
            <Toaster position="top-center" reverseOrder={false} />
          </GoogleOAuthProvider>
        </UsersProvider>
      </UserProvider>
    </BrowserRouter>
  );
}

bootstrap();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
